// export const tutorial_tag = [
//   {
//     title: "AI编程语言",
//     key: "1",
//     value: "1",
//     children: [{ title: "Python", key: "1_1", value: "1_1" }],
//   },
//   {
//     title: "机器学习",
//     key: "2",
//     value: "2",
//     children: [
//       { title: "监督学习", key: "2_1", value: "2_1" },
//       { title: "无监督学习", key: "2_2", value: "2_2" },
//       { title: "半监督学习", key: "2_3", value: "2_3" },
//     ],
//   },
//   {
//     title: "深度学习",
//     key: "3",
//     value: "3",
//     children: [
//       { title: "TensorFlow", key: "3_1", value: "3_1" },
//       { title: "PyTorch", key: "3_2", value: "3_2" },
//     ],
//   },
//   {
//     title: "机器学习算法",
//     key: "4",
//     value: "4",
//     children: [
//       { title: "线性回归", key: "4_1", value: "4_1" },
//       { title: "逻辑回归", key: "4_2", value: "4_2" },
//       { title: "决策树", key: "4_3", value: "4_3" },
//       { title: "随机森林", key: "4_4", value: "4_4" },
//       { title: "驳类", key: "4_5", value: "4_5" },
//       { title: "关联规则", key: "4_6", value: "4_6" },
//       { title: "时间差学习", key: "4_7", value: "4_7" },
//       { title: "Q-learning", key: "4_8", value: "4_8" },
//     ],
//   },
//   {
//     title: "深度学习算法",
//     key: "5",
//     value: "5",
//     children: [
//       { title: "卷积神经网络CNN", key: "5_1", value: "5_1" },
//       { title: "循环神经网络RNN", key: "5_2", value: "5_2" },
//       { title: "生成对抗网络GANs", key: "5_3", value: "5_3" },
//       { title: "深度强化学习RL", key: "5_4", value: "5_4" },
//     ],
//   },
//   {
//     title: "数据处理可视化",
//     key: "6",
//     value: "6",
//     children: [
//       { title: "数据清洗", key: "6_1", value: "6_1" },
//       { title: "数据预处理", key: "6_2", value: "6_2" },
//       { title: "特征工程", key: "6_3", value: "6_3" },
//       { title: "Matplotlib", key: "6_4", value: "6_4" },
//     ],
//   },
//   {
//     title: "自然语言处理",
//     key: "7",
//     value: "7",
//     children: [
//       { title: "NLTK", key: "7_1", value: "7_1" },
//       { title: "SpaCy", key: "7_2", value: "7_2" },
//     ],
//   },
//   {
//     title: "计算机视觉",
//     key: "8",
//     value: "8",
//     children: [
//       { title: "openCV", key: "8_1", value: "8_1" },
//       { title: "PyTorch", key: "8_2", value: "8_2" },
//     ],
//   },
//   {
//     title: "AI强化学习",
//     key: "9",
//     value: "9",
//     children: [
//       { title: "OpenAI Gym", key: "9_1", value: "9_1" },
//       { title: "RLlib", key: "9_2", value: "9_2" },
//     ],
//   },
//   {
//     title: "创建AI模型",
//     key: "10",
//     value: "10",
//   },
// ];
export const tutorial_tag = [
  // 大模型开发、模型调优、Agents、数据标注、训练推理、模型部署、行业+LLM、自动驾驶、具身智能、机器人
  {
    title: "大模型开发",
    key: "11",
    value: "11",
  },
  {
    title: "模型调优",
    key: "12",
    value: "12",
  },
  {
    title: "Agents",
    key: "13",
    value: "13",
  },
  {
    title: "数据标注",
    key: "14",
    value: "14",
  },
  {
    title: "训练推理",
    key: "15",
    value: "15",
  },
  {
    title: "模型部署",
    key: "16",
    value: "16",
  },
  {
    title: "行业+LLM",
    key: "17",
    value: "17",
  },
  {
    title: "自动驾驶",
    key: "18",
    value: "18",
  },
  {
    title: "具身智能",
    key: "19",
    value: "19",
  },
  {
    title: "机器人",
    key: "20",
    value: "20",
  },
];
export const video_bq = [
  // { key: 1, value: "图像处理" },
  // { key: 2, value: "深度学习 " },
  // { key: 3, value: "计算机视觉" },
  // { key: 4, value: "机器学习" },
  // { key: 5, value: "自然语言处理" },
  // { key: 6, value: "pytorch" },
  { key: "7", value: "全部" },
  { key: "8", value: "Agents" },
  { key: "9", value: "大模型开发" },
  { key: "10", value: "模型调优" },
  { key: "11", value: "AI数据" },
  { key: "12", value: "训练推理" },
  { key: "13", value: "AI技术原理" },
  { key: "14", value: "AI基础研究" },
  { key: "15", value: "具身智能" },
  { key: "16", value: "机器人" },
  { key: "17", value: "行业+" },
  { key: "18", value: "其他" },
];
export const video_bq_add = [
  // { key: 1, value: "图像处理" },
  // { key: 2, value: "深度学习 " },
  // { key: 3, value: "计算机视觉" },
  // { key: 4, value: "机器学习" },
  // { key: 5, value: "自然语言处理" },
  // { key: 6, value: "pytorch" },
  { key: "8", value: "Agents" },
  { key: "9", value: "大模型开发" },
  { key: "10", value: "模型调优" },
  { key: "11", value: "AI数据" },
  { key: "12", value: "训练推理" },
  { key: "13", value: "AI技术原理" },
  { key: "14", value: "AI基础研究" },
  { key: "15", value: "具身智能" },
  { key: "16", value: "机器人" },
  { key: "17", value: "行业+" },
  { key: "18", value: "其他" },
];
